// app.config.ts — single per-app config surface.
// Replace placeholder values; do not change the shape.
// Shape is enforced by scripts/lib/config-loader.ts at build time.

export const config = {
  app: {
    name: 'Ebolamap',
    domain: 'ebolamap.app',
    description: 'A public-good map and historical tracker of every documented ebolavirus outbreak.',
    locales: ['en'] as const,
    defaultLocale: 'en',
  },
  branding: {
    logoLight: '/branding/logo-light.svg',
    logoDark: '/branding/logo-dark.svg',
    favicon: '/branding/favicon.svg',
    ogTemplate: '/branding/og-template.svg',
    colors: { primary: '#dc2626', accent: '#f59e0b', danger: '#7f1d1d' },
  },
  map: {
    styleDark:  'mapbox://styles/mapbox/satellite-streets-v12',
    styleLight: 'mapbox://styles/mapbox/satellite-streets-v12',
    defaultCenter: [20, 0] as [number, number],
    defaultZoom: 2.5,
  },
  taxonomy: {
    categoryField: 'pathogen',
    categoryLabel: 'Pathogen',
    categories: [
      { id: 'zaire-ebolavirus',     label: 'Zaire ebolavirus',     color: '#7f1d1d' },
      { id: 'sudan-ebolavirus',     label: 'Sudan ebolavirus',     color: '#dc2626' },
      { id: 'bundibugyo-ebolavirus',label: 'Bundibugyo ebolavirus',color: '#ea580c' },
      { id: 'tai-forest-ebolavirus',label: 'Taï Forest ebolavirus',color: '#f59e0b' },
      { id: 'reston-ebolavirus',    label: 'Reston ebolavirus',    color: '#a16207' },
      { id: 'bombali-ebolavirus',   label: 'Bombali ebolavirus',   color: '#78716c' },
      { id: 'unspecified',          label: 'Unspecified ebolavirus', color: '#64748b' },
    ],
    secondaryField: undefined,
    secondaryLabel: undefined,
    secondaryValues: undefined,
  },
  counts: {
    fields: [
      { id: 'confirmed', label: 'Confirmed cases', sanityCap: 100000, primary: true },
      { id: 'suspected', label: 'Suspected cases', sanityCap: 100000, primary: false },
      { id: 'deaths',    label: 'Deaths',          sanityCap: 100000, primary: false },
      { id: 'cfr_pct',   label: 'Case fatality rate (%)', sanityCap: 100, primary: false },
    ],
  },
  sourceTiers: [
    { tier: 1, label: 'Official (WHO/CDC/MoH)',     autoPublish: false as const },
    { tier: 2, label: 'Peer-reviewed retrospective',autoPublish: false as const },
    { tier: 3, label: 'NGO operational reports',    autoPublish: false as const },
    { tier: 4, label: 'Contemporaneous press',      autoPublish: false as const },
  ],
} as const;

export type AppConfig = typeof config;
export type Locale = AppConfig['app']['locales'][number];
